/**
 * Thrown when the Swimlane Store tries to find the supplied IBoard
 * within the BoardStore but cannot find it.
 */
class BoardNotFoundError extends Error {
    constructor(id: number) {
        super(`BoardNotFound: { id:${id} }`)
        this.name = 'BoardNotFoundError'
    }
}

export default BoardNotFoundError
